module.exports = window["MaterialUI"].Tab;